import { motion } from "framer-motion";

// Fades/slides a section in the moment it scrolls into view, instead of
// everything just being present on load -- `once: true` so it never replays
// on scroll-back-up, and the small negative bottom margin triggers it a touch
// before the section is fully on screen so it doesn't feel late.
export default function Reveal({ children, className, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -80px 0px" }}
      transition={{ duration: 0.7, ease: "easeOut", delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
